"use client";

import { useEffect } from "react";

import {
  STATEWIDE_JOB_SEARCH_ORIGIN,
  useJobSearchOrigin,
} from "@/stores/use-job-search-origin";

export default function StatewideBoardOriginTracker(): null {
  const { setOrigin } = useJobSearchOrigin();

  useEffect(() => {
    setOrigin(STATEWIDE_JOB_SEARCH_ORIGIN);
  }, [setOrigin]);

  return null;
}
